module.exports = __webpack_public_path__ + "static/64-3b0e79add16058f580936e537c87a273.png";